// eslint-disable-next-line import/no-named-default,import/no-unresolved
import { default as uiElements } from './UiElements'
// eslint-disable-next-line import/no-unresolved,import/no-named-default
import { default as formElements } from './Forms'

export default function Components(Vue) {
  Vue.use(formElements)
  Vue.use(uiElements)
}



// WEBPACK FOOTER //
// ./src/js/components/app/index.js